// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.document-list {
  margin-top: 20px;
}

.list-description {
  color: #666;
  font-size: 14px;
  margin: 10px 0 20px 0;
  font-style: italic;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

/* Center status badge containers in table cells */
.status-cell {
  text-align: center;
}

.status-cell > div {
  justify-content: center;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
}

th.sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  transition: background-color 0.15s ease;
}

th.sortable:hover {
  background-color: #e9ecef;
}

th.sorted-asc {
  background-color: #d4edda;
}

th.sorted-desc {
  background-color: #f8d7da;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

tr:hover {
  background-color: #f1f1f1;
}

.status-approved {
  background-color: #dfffdf;
}

.status-processing {
  background-color: #ffffdf;
}

.status-failed {
  background-color: #ffdfdf;
}

.status-rejected {
  background-color: #ffe0e0;
}

.status-review_required {
  background-color: #ffeecc;
}

.no-documents {
  margin: 40px 0;
  font-size: 18px;
  color: #666;
}

.document-link {
  background: none;
  border: none;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
}

.document-link:hover {
  color: #0056b3;
  text-decoration: none;
}

.audit-link {
  background: none;
  border: none;
  color: #28a745;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
}

.audit-link:hover {
  color: #1e7e34;
  text-decoration: none;
}

/* Action buttons */
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
}

.action-btn {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
  min-width: 50px;
}

.preview-btn {
  background-color: #17a2b8;
  color: white;
}

.preview-btn:hover {
  background-color: #138496;
}

.edit-btn {
  background-color: #ffc107;
  color: #212529;
}

.edit-btn:hover {
  background-color: #e0a800;
}

.download-btn {
  background-color: #28a745;
  color: white;
}

.download-btn:hover {
  background-color: #218838;
}

.audit-btn {
  background-color: #6f42c1;
  color: white;
}

.audit-btn:hover {
  background-color: #5a2d91;
}

/* Responsive action buttons */
@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 3px;
  }

  .action-btn {
    font-size: 11px;
    padding: 3px 6px;
    min-width: 45px;
  }
}

.comments-cell {
  max-width: 200px;
  word-wrap: break-word;
  white-space: pre-wrap;
}

/* Filter Controls Styling */
.filter-controls {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.filter-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: wrap;
  align-items: end;
}

.filter-row:last-child {
  margin-bottom: 0;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 150px;
  flex: 1 1;
}

.filter-group label {
  font-weight: bold;
  color: #495057;
  font-size: 14px;
}

.filter-group input,
.filter-group select {
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.filter-group input:focus,
.filter-group select:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.filter-group input[type="date"] {
  cursor: pointer;
}

.filter-group input[type="number"] {
  min-width: 120px;
}

.clear-filters-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.15s ease-in-out;
  height: fit-content;
}

.clear-filters-btn:hover {
  background-color: #5a6268;
}

.clear-filters-btn:active {
  background-color: #545b62;
}

/* Filter section headers */
.filter-section-header {
  margin-top: 15px;
  margin-bottom: 10px;
  padding-top: 15px;
  border-top: 1px solid #dee2e6;
}

.filter-section-header h3 {
  color: #495057;
  font-size: 16px;
  margin: 0;
  padding: 0;
  font-weight: 600;
}

/* Sort Controls */
.sort-controls {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.sort-info {
  color: #495057;
  font-size: 14px;
}

.sort-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.sort-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: background-color 0.15s ease;
  white-space: nowrap;
}

.sort-btn:hover {
  background-color: #5a6268;
}

.sort-btn:active {
  background-color: #545b62;
}

/* Collapsible comments styling */
.comments-cell {
  max-width: 300px;
  position: relative;
}

.collapsible-comments {
  width: 100%;
}

.comments-preview {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.comments-text {
  flex: 1 1;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 1.4;
  font-size: 14px;
}

.comments-toggle {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  width: 18px;
  height: 18px;
  font-size: 10px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
  line-height: 1;
}

.comments-toggle:hover {
  background-color: #0056b3;
}

.comments-toggle:active {
  transform: scale(0.95);
}

/* Responsive design for filters */
@media (max-width: 768px) {
  .filter-row {
    flex-direction: column;
  }

  .filter-group {
    min-width: auto;
    width: 100%;
  }

  .comments-cell {
    max-width: 200px;
  }
}

/* Processing spinner animation */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.processing-spinner {
  animation: spin 1s linear infinite;
}

/* Refresh indicator */
.refresh-indicator {
  position: fixed;
  top: 20px;
  right: 20px;
  background: rgba(0, 123, 255, 0.9);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Status badge styling - colored status indicators */
.status-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  min-width: 60px; /* Ensure consistent minimum width */
  text-align: center; /* Center text within badge */
}

.status-badge.processing {
  background-color: #007bff;
  color: white;
}

.status-badge.approved {
  background-color: #28a745;
  color: white;
}

.status-badge.rejected {
  background-color: #dc3545;
  color: white;
}

.status-badge.review_required {
  background-color: #ffc107;
  color: #212529;
}

.status-badge.processed {
  background-color: #17a2b8;
  color: white;
}

.status-badge.pending {
  background-color: #6c757d;
  color: white;
}

.status-badge.opened {
  background-color: #fd7e14;
  color: white;
}

.status-badge.reviewed {
  background-color: #20c997;
  color: white;
}

.status-badge.failed {
  background-color: #dc3545;
  color: white;
}

.status-badge.error {
  background-color: #dc3545;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/DocumentList.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,wEAAwE;AAC1E;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe,EAAE,oCAAoC;EACrD,kBAAkB,EAAE,6BAA6B;AACnD;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".document-list {\n  margin-top: 20px;\n}\n\n.list-description {\n  color: #666;\n  font-size: 14px;\n  margin: 10px 0 20px 0;\n  font-style: italic;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\nth, td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\n/* Center status badge containers in table cells */\n.status-cell {\n  text-align: center;\n}\n\n.status-cell > div {\n  justify-content: center;\n}\n\nth {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\nth.sortable {\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  transition: background-color 0.15s ease;\n}\n\nth.sortable:hover {\n  background-color: #e9ecef;\n}\n\nth.sorted-asc {\n  background-color: #d4edda;\n}\n\nth.sorted-desc {\n  background-color: #f8d7da;\n}\n\ntr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\ntr:hover {\n  background-color: #f1f1f1;\n}\n\n.status-approved {\n  background-color: #dfffdf;\n}\n\n.status-processing {\n  background-color: #ffffdf;\n}\n\n.status-failed {\n  background-color: #ffdfdf;\n}\n\n.status-rejected {\n  background-color: #ffe0e0;\n}\n\n.status-review_required {\n  background-color: #ffeecc;\n}\n\n.no-documents {\n  margin: 40px 0;\n  font-size: 18px;\n  color: #666;\n}\n\n.document-link {\n  background: none;\n  border: none;\n  color: #007bff;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: inherit;\n  padding: 0;\n}\n\n.document-link:hover {\n  color: #0056b3;\n  text-decoration: none;\n}\n\n.audit-link {\n  background: none;\n  border: none;\n  color: #28a745;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: inherit;\n  padding: 0;\n}\n\n.audit-link:hover {\n  color: #1e7e34;\n  text-decoration: none;\n}\n\n/* Action buttons */\n.action-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  justify-content: center;\n}\n\n.action-btn {\n  padding: 4px 8px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  min-width: 50px;\n}\n\n.preview-btn {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.preview-btn:hover {\n  background-color: #138496;\n}\n\n.edit-btn {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.edit-btn:hover {\n  background-color: #e0a800;\n}\n\n.download-btn {\n  background-color: #28a745;\n  color: white;\n}\n\n.download-btn:hover {\n  background-color: #218838;\n}\n\n.audit-btn {\n  background-color: #6f42c1;\n  color: white;\n}\n\n.audit-btn:hover {\n  background-color: #5a2d91;\n}\n\n/* Responsive action buttons */\n@media (max-width: 768px) {\n  .action-buttons {\n    flex-direction: column;\n    gap: 3px;\n  }\n\n  .action-btn {\n    font-size: 11px;\n    padding: 3px 6px;\n    min-width: 45px;\n  }\n}\n\n.comments-cell {\n  max-width: 200px;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n/* Filter Controls Styling */\n.filter-controls {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.filter-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n  align-items: end;\n}\n\n.filter-row:last-child {\n  margin-bottom: 0;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 150px;\n  flex: 1;\n}\n\n.filter-group label {\n  font-weight: bold;\n  color: #495057;\n  font-size: 14px;\n}\n\n.filter-group input,\n.filter-group select {\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: white;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.filter-group input:focus,\n.filter-group select:focus {\n  outline: none;\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.filter-group input[type=\"date\"] {\n  cursor: pointer;\n}\n\n.filter-group input[type=\"number\"] {\n  min-width: 120px;\n}\n\n.clear-filters-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.15s ease-in-out;\n  height: fit-content;\n}\n\n.clear-filters-btn:hover {\n  background-color: #5a6268;\n}\n\n.clear-filters-btn:active {\n  background-color: #545b62;\n}\n\n/* Filter section headers */\n.filter-section-header {\n  margin-top: 15px;\n  margin-bottom: 10px;\n  padding-top: 15px;\n  border-top: 1px solid #dee2e6;\n}\n\n.filter-section-header h3 {\n  color: #495057;\n  font-size: 16px;\n  margin: 0;\n  padding: 0;\n  font-weight: 600;\n}\n\n/* Sort Controls */\n.sort-controls {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 15px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.sort-info {\n  color: #495057;\n  font-size: 14px;\n}\n\n.sort-buttons {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.sort-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  transition: background-color 0.15s ease;\n  white-space: nowrap;\n}\n\n.sort-btn:hover {\n  background-color: #5a6268;\n}\n\n.sort-btn:active {\n  background-color: #545b62;\n}\n\n/* Collapsible comments styling */\n.comments-cell {\n  max-width: 300px;\n  position: relative;\n}\n\n.collapsible-comments {\n  width: 100%;\n}\n\n.comments-preview {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.comments-text {\n  flex: 1;\n  word-wrap: break-word;\n  word-break: break-word;\n  line-height: 1.4;\n  font-size: 14px;\n}\n\n.comments-toggle {\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  width: 18px;\n  height: 18px;\n  font-size: 10px;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.15s ease;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.comments-toggle:hover {\n  background-color: #0056b3;\n}\n\n.comments-toggle:active {\n  transform: scale(0.95);\n}\n\n/* Responsive design for filters */\n@media (max-width: 768px) {\n  .filter-row {\n    flex-direction: column;\n  }\n\n  .filter-group {\n    min-width: auto;\n    width: 100%;\n  }\n\n  .comments-cell {\n    max-width: 200px;\n  }\n}\n\n/* Processing spinner animation */\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.processing-spinner {\n  animation: spin 1s linear infinite;\n}\n\n/* Refresh indicator */\n.refresh-indicator {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background: rgba(0, 123, 255, 0.9);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Status badge styling - colored status indicators */\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: inline-block;\n  min-width: 60px; /* Ensure consistent minimum width */\n  text-align: center; /* Center text within badge */\n}\n\n.status-badge.processing {\n  background-color: #007bff;\n  color: white;\n}\n\n.status-badge.approved {\n  background-color: #28a745;\n  color: white;\n}\n\n.status-badge.rejected {\n  background-color: #dc3545;\n  color: white;\n}\n\n.status-badge.review_required {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.status-badge.processed {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.status-badge.pending {\n  background-color: #6c757d;\n  color: white;\n}\n\n.status-badge.opened {\n  background-color: #fd7e14;\n  color: white;\n}\n\n.status-badge.reviewed {\n  background-color: #20c997;\n  color: white;\n}\n\n.status-badge.failed {\n  background-color: #dc3545;\n  color: white;\n}\n\n.status-badge.error {\n  background-color: #dc3545;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
